import { 
  SELECT_BASE_PACK, 
  REMOVE_BASE_PACK,
  SELECT_BASE_OPTION,
  SELECT_ADD_ON,
  REMOVE_BASE_OPTION,
  REMOVE_ADD_ON
} from './pack.builder.actions.constants';

export const packBuilder = (state = {}, action) => {
  console.log(action.type)
  switch(action.type) {
    case SELECT_BASE_PACK: 
      return {
        ...state,
        selectedBasePack: action.payload,
      }
    case REMOVE_BASE_PACK:
      return {
        ...state,
        selectedBasePack: {}
      }
    case SELECT_BASE_OPTION: 
      if(!state.selectedBaseOptions.find((option) => option.id === action.payload.id)) {
        return {
          ...state,
          selectedBaseOptions: [...state.selectedBaseOptions, action.payload]
        } 
      } else {
        return {
          ...state,
          selectedBaseOptions: state.selectedBaseOptions.map(baseOption => {
            if (baseOption.id === action.payload.id) {
              return {...baseOption, selectedValue: action.payload.selectedValue}
            } 
            return baseOption;
          })
        }
      }
    case SELECT_ADD_ON: 
      if(!state.selectedAddOns.find((addOn) => addOn.id === action.payload.id)) {
        return {
          ...state,
          selectedAddOns: [...state.selectedAddOns, action.payload]
        } 
      } else {
        return {
          ...state,
          selectedAddOns: state.selectedAddOns.map(addOn => {
            if (addOn.id === action.payload.id) {
              return {...addOn, selectedValue: action.payload.selectedValue}
            } 
            return addOn;
          })
        }
      }
    case REMOVE_BASE_OPTION:
      return {
        ...state,
        selectedBaseOptions: state.selectedBaseOptions.filter(baseOption => baseOption.id !== action.payload.id )
      }
    case REMOVE_ADD_ON:
      return {
        ...state,
        selectedAddOns: state.selectedAddOns.filter(addOn => addOn.id !== action.payload.id )
      }
    default: 
      return state;
  }
}